import { useDispatch } from "react-redux";
import { bindActionCreators, createAction } from "@reduxjs/toolkit";
import { ActionType } from "./types/actionType";
import {
  GetMrnCategoryPayload,
  CreateMrnCategoryPayload,
  DeleteMrnCategoryPayload,
  UpdateMrnCategoryPayload,
  GetManyMrnCategoriesPayload,
} from "./types/types";

export const createMrnCategory = createAction<CreateMrnCategoryPayload>(
  ActionType.CREATE_MRN_CATEGORY
);

export const updateMrnCategory = createAction<UpdateMrnCategoryPayload>(
  ActionType.UPDATE_MRN_CATEGORY
);

export const deleteMrnCategory = createAction<DeleteMrnCategoryPayload>(
  ActionType.DELETE_MRN_CATEGORY
);

export const retrieveMrnCategory = createAction<GetMrnCategoryPayload>(
  ActionType.RETRIEVE_MRN_CATEGORY
);

export const retrieveManyMrnCategories = createAction<GetManyMrnCategoriesPayload>(
  ActionType.RETRIEVE_MANY_MRN_CATEGORIES
);

export const useActions = () => {
  const dispatch = useDispatch();
  return bindActionCreators(
    {
      createMrnCategory,
      updateMrnCategory,
      deleteMrnCategory,
      retrieveMrnCategory,
      retrieveManyMrnCategories,
    },
    dispatch
  );
};

export const sagaActions = {
  createMrnCategory,
  updateMrnCategory,
  deleteMrnCategory,
  retrieveMrnCategory,
  retrieveManyMrnCategories,
};
